module.exports = __webpack_public_path__ + "img/en.01873bcc.png";